import { useState } from 'react';
import { Job } from '@recruitai/shared';
import { apiClient } from '../lib/api-client';

interface UseCloneJobResult {
  cloneJob: (jobId: string) => Promise<Job>;
  isCloning: boolean;
  error: Error | null;
}

export function useCloneJob(): UseCloneJobResult {
  const [isCloning, setIsCloning] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const cloneJob = async (jobId: string): Promise<Job> => {
    try {
      setIsCloning(true);
      setError(null);

      const job = await apiClient.post<Job>(`/jobs/${jobId}/clone`, {});
      return job;
    } catch (err) {
      const error = err instanceof Error ? err : new Error('Failed to clone job');
      setError(error);
      throw error;
    } finally {
      setIsCloning(false);
    }
  };

  return {
    cloneJob,
    isCloning,
    error,
  };
}
